// NOTE: This relies on the old analytics/js file's init function being called
// Still uses the global variable "ga"
import Analytics from "../../analytics";

export const gaEvent = (category, label = "", action = "click") => {
  Analytics.gaEvent(category, action, label);
};
